const AUTH_RESPONSE = 'AUTH_RESPONSE';
const SELECTED_CATEGORY = 'SELECTED_CATEGORY';

export default { AUTH_RESPONSE, SELECTED_CATEGORY };
